
import useOrbit from "./useOrbit";

const useOrbitParams = () => {

    const { orbitParams, launchDetails, getLaunchDetails } = useOrbit()

    return { orbitParams, launchDetails, getLaunchDetails }
};

export default useOrbitParams;